const getTimestamp = Math.round(Date.now() / 1000);
export default getTimestamp;
